module.exports = __webpack_public_path__ + "img/icon-check-blue.77118472.svg";